import { Axios, AxiosRequestConfig } from 'axios';

import { AppContext, AppContextKeys } from '@/types/common';

import { PlainObject } from '../types';
import { getAppCtx } from './appCtx';
export * from './appCtx';

interface DollarGT {
  (val: string, namespace?: null | string, params?: PlainObject): string;
  (val: string, ...args: any): string;
}

const getAppCtxProxy = () => {
  const debugWarn = (p: string, target: any) => {
    console.debug(
      `[React Runtime] No Vue context runtime found, please check the key name is: "${p}" in target object:`,
      target
    );
  };
  const context = {};
  return new Proxy(context, {
    get(_, p: AppContextKeys, receiver) {
      const ctx = getAppCtx();
      if (!ctx || typeof ctx !== 'object') return undefined;
      const res = Reflect.get(ctx, p, receiver);
      if (!res) {
        debugWarn(p, ctx);
        return undefined;
      }
      return res;
    },
  }) as Partial<AppContext>;
};

const AppCtx = getAppCtxProxy();

export const IN_ADMIN_CONTEXT = !!getAppCtx();

export const VueCtxRouter = AppCtx.router;

export const VueCtxStore = AppCtx.store;

export const request = {
  get<T=any>(url: string, config?: AxiosRequestConfig, extraParams?: any) : Promise<T> {
    return (AppCtx.request as unknown as any).get(url, config, extraParams);
  },
  post<T=any>(url: string, data?: object, config?: AxiosRequestConfig, extraParams?: any) :Promise<T> {
    return (AppCtx.request as any).post(url, data, config, extraParams);
  },
  put <T = any>(url: string, data?: object, config?: AxiosRequestConfig): Promise<T> {
    return (AppCtx.request as unknown as Axios).put(url, data, config);
  },
  delete<T=any>(url: string, config?: AxiosRequestConfig) : Promise<T> {
    return (AppCtx.request as unknown as Axios).delete(url, config);
  },
};

export const VueI18n = AppCtx.i18n;

export const $gt: DollarGT = AppCtx.gt ? AppCtx.gt : t => t;

export const baseURL = __BASEURL__ || window.location.origin;

export default AppCtx;
